<template>
    <div class="nav-box">
        <nav class="nav">
            <ul>
                <li :class="{ 'active': $route.name === 'Requests' }">
                    <router-link to="/manage/requests" tag="li" exact-active-class="active">
                        <icon-base width="30" height="30" viewBox="0 0 30 30"><icon-requests/></icon-base>
                        <span>Requests</span>
                    </router-link>
                </li>
                <li :class="{ 'active': $route.name === 'Customers' }">
                    <router-link to="/manage/customers">
                        <icon-base width="30" height="30" viewBox="0 0 30 30"><icon-customers/></icon-base>
                        <span>Customers</span>
                    </router-link>
                </li>
                <li :class="{ 'active': $route.name === 'LX-Terminals' }">
                    <router-link to="/manage/lx-terminals">
                        <icon-base width="30" height="30" viewBox="0 0 30 30"><icon-lx-terminals/></icon-base>
                        <span>LXTerminals</span>
                    </router-link>
                </li>
                <li :class="{ 'active': $route.name === 'Settings' }">
                    <router-link to="/manage/settings">
                        <icon-base width="30" height="30" viewBox="0 0 30 30"><icon-settings/></icon-base>
                        <span>Settings</span>
                    </router-link>
                </li>
            </ul>
        </nav>
    </div>
</template>

<script>
//import {mapMutations, mapActions, mapState} from "vuex"

import IconBase from "../common/IconBase";
import IconRequests from "../common/icons/IconRequests";
import IconCustomers from "../common/icons/IconCustomers";
import IconLxTerminals from "../common/icons/IconLXTerminals";
import IconSettings from "../common/icons/IconSettings";
export default {
    name: 'admin-nav',

    components: {IconSettings, IconLxTerminals, IconCustomers, IconRequests, IconBase},

    computed: {
        /*...mapState({
            popupData: state => state.popupData,
        }),*/
    },

    methods: {
       /* ...mapMutations([
            'switchPopup',
        ]),
        ...mapActions('events', [
            'deleteEvent',
            'loadEvents'
        ]),
        cancelClick() {
            this.switchPopup(false);
        },
        confirmClick() {
            this.deleteEvent(this.popupData.id).then(() => {
                this.loadEvents();
                this.switchPopup(false);
            }).catch((message) => {
                alert(message)
            });
        },*/
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
